import React from 'react';
import { Menu, Modal, message } from 'antd';
import { Link } from 'react-router-dom';
import { Draggable } from 'react-beautiful-dnd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { deleteGroup } from 'api/events';
import GroupCard from 'componentsv2/GroupCard/GroupCard';
import EllipsisDropdown from 'componentsv2/shared-components/EllipsisDropdown';

const GroupCardContainer = ({
  title,
  contents,
  index,
  isScrollable,
  isCombineEnabled,
  useClone,
  id,
  roundsGenerated,
  isPositionTable,
  event,
  reloadGroups,
}) => {
  const onBoardDelete = (title, groupId) => {
    Modal.confirm({
      title: `¿Estas seguro que deseas eliminar el grupo "${title}"?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'Cancelar',
      async onOk() {
        try {
          await deleteGroup(groupId);
          await reloadGroups();
          message.success('!El grupo fue eliminado!');
        } catch (error) {
          message.error('!Ha ocurrido un error!');
        }
      },
    });
  };

  return (
    <Draggable draggableId={String(id)} index={index} isDragDisabled={true}>
      {(provided, snapshot) => (
        <div className="board-column" ref={provided.innerRef} {...provided.draggableProps}>
          <div className="board-title" {...provided.dragHandleProps}>
            <>
              <h4 className="mb-0">{title}</h4>
              {!isPositionTable && (
                <EllipsisDropdown
                  menu={
                    <Menu>
                      <Menu.Item onClick={() => onBoardDelete(title, id)}>
                        <DeleteOutlined />
                        <span>Eliminar grupo</span>
                      </Menu.Item>
                    </Menu>
                  }
                />
              )}
            </>
          </div>
          <GroupCard
            listId={isPositionTable ? String(id + 'PT') : String(id)}
            listType="CONTENT"
            className={snapshot.isDragging ? 'is-dragging' : ''}
            contents={contents}
            roundsGenerated={roundsGenerated}
            internalScroll={isScrollable}
            isCombineEnabled={isCombineEnabled}
            useClone={useClone}
            reloadGroups={reloadGroups}
          />
          <div className={roundsGenerated ? 'board-add' : 'board-add-not'}>
            {roundsGenerated && (
              <Link to={`/dashboard/v2/evento/${event.id}/jornadas/${id}`}>Ver Jornadas</Link>
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default GroupCardContainer;
